import React from "react";

export function formatDateTime(dateString) {
  if (!dateString) return "-";

  const date = new Date(dateString);

  // ✅ prevent RangeError
  if (isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}
